import { updateKeyInStore } from 'App';
import { store } from 'app/redux/store';
import { countries } from 'countries';
import * as Yup from 'yup';
import { requiredFiles } from '../../useValidateQuestionnaire';
import {
  PensionStateValues,
  TCountryPensionType,
  TCountryPensionTypeRow,
  updateFieldArrayKey,
  updateKey,
} from './slice';

// predicate:
// 'Displayed in case the user selects "Yes" to the Wages question in the General tab.',

export const fields: IBaseField<
  keyof PensionStateValues | keyof TCountryPensionTypeRow
>[] = [
  {
    dependenciesTitle: 'pensionContributions',
    name: 'didYouMakeContributionsToAUsIraRothIraOrSepAccountsDuringTheFilingYear',
    label:
      'Did you make contributions to a US IRA, ROTH IRA, or SEP accounts during the filing year?',
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependencies: [
      {
        name: 'form5498ReportingIraorRothIraContributionForTaxYear',
        label:
          'Form 5498 reporting IRA (or ROTH IRA) contribution for tax year',
        type: 'upload',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        predicate: (value) => value === 'yes',
      },
    ],
  },

  {
    dependenciesTitle: 'Pension Distributions',
    name: 'didYouReceiveUsRetirementDistributions',
    label: 'Did you receive US retirement distributions?',
    subLabel: () => (
      <p>Ie Social Secuiry, IRA, 401-K, government or military pension</p>
    ),
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependencies: [
      {
        name: 'pleaseUploadForm1099ROrSsa1099',
        label: 'Please upload form 1099-R or SSA-1099',
        type: 'upload',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
      {
        name: 'nonTaxesPaidOnUsRetirementDistributions',
        label: 'Non-taxes paid on US retirement distributions',
        type: 'currency',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
    ],
  },
  {
    name: 'didYouReceiveForeignieNonUsRetirementDistributions',
    label: 'Did you receive Foreign (ie Non-US) retirement distributions?',
    subLabel: () => (
      <p>Such as government/ private pension or disability payments?</p>
    ),
    type: 'upload',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependencies: [
      {
        name: 'countryPensionType',
        label: 'Country & Pension Type',
        type: 'fieldArray',
        tooltip: '',
        comment: true,
        effect: (payload) => store.dispatch(updateFieldArrayKey(payload)),
        defaultDependency: {
          grossAmountReceived: null,
          country: null,
          pensionType: null,
          foreignTaxPaid: null,
        },
        dependencies: [
          {
            name: 'grossAmountReceived',
            label: 'Gross Amount Received',
            type: 'currency',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },

          {
            name: 'country',
            label: 'Country',
            type: 'country',
            placeholder: 'Select Country',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
          {
            name: 'pensionType',
            label: 'Pension Type',
            type: 'select',
            options: [
              {
                label: 'Social Security',
                value: 'Social Security',
              },
              {
                label: 'Employer Pension',
                value: 'Employer Pension',
              },
              {
                label: 'Individual Pension',
                value: 'Individual Pension',
              },
            ],
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
          {
            name: 'foreignTaxPaid',
            label: 'Foreign Tax Paid',
            type: 'currency',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
        ],
      },
    ],
  },
  {
    name: 'didYouPerformARolloverBetweenTraditionalIraAndRothIra',
    label: 'Did you perform a rollover between Traditional IRA and Roth IRA?',
    subLabel: () => <p>Refers to either complete or partial rollover</p>,
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependencies: [
      {
        name: 'pleaseUploadSupportingDocumentation',
        label: 'Please upload supporting documentation',
        type: 'upload',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
    ],
  },
];

export const validationSchema = Yup.object().shape({});
